import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import AltenarSportsbook from 'components/Sportsbook/altenar/AltenarSportsbook';
import FirstSportsbook from 'components/Sportsbook/Custom/FirstSportsbook';

export const SPORTSBOOK_PROVIDERS = {
  ALTENAR: 'Altenar',
  FIRST: 'First',
};

const providerRegistry = {
  [SPORTSBOOK_PROVIDERS.ALTENAR]: () => {
    const cfg = SiteConfigManager.getConfig('config.config.sportsbookIntegrator.altenar') || {};
    const integration = SiteConfigManager.getConfig(
      'config.config.sportsbookIntegrator.altenarIntegrationName',
    );
    return <AltenarSportsbook culture={cfg.culture} integration={integration} />;
  },
  [SPORTSBOOK_PROVIDERS.FIRST]: () => {
    const iframeLink = SiteConfigManager.getConfig(
      'config.config.sportsbookIntegrator.linkForFirstDomain',
    );
    if (!iframeLink) return null;
    return <FirstSportsbook iframeLink={iframeLink} />;
  },
};

export const getConfiguredSportsbookProvider = () => {
  const linkForFirstDomain = SiteConfigManager.getConfig(
    'config.config.sportsbookIntegrator.linkForFirstDomain',
  );
  if (linkForFirstDomain) return SPORTSBOOK_PROVIDERS.FIRST;
  const altenarIntegrationName = SiteConfigManager.getConfig(
    'config.config.sportsbookIntegrator.altenarIntegrationName',
  );
  if (altenarIntegrationName) return SPORTSBOOK_PROVIDERS.ALTENAR;
  return null;
};

export const renderSportsbookProvider = () => {
  const key = getConfiguredSportsbookProvider();
  if (!key) return null;
  const render = providerRegistry[key];
  return render ? render() : null;
};
